import { generateImg,generateImgReq, img2img } from './generate-img-api';


export async function ganStyleTypeTo(modelType){
  var GanStyle_subStyle_name='GanStyle'
var chooseGanStyleType='base'
  if(modelType==1){
    GanStyle_subStyle_name='base'
    chooseGanStyleType='base'
  }else if(modelType==2){
    GanStyle_subStyle_name='mona_lisa'
    chooseGanStyleType='mona_lisa'
  }else if(modelType==3){
    GanStyle_subStyle_name='modigliani'
    chooseGanStyleType='modigliani'
  }else if(modelType==4){
    GanStyle_subStyle_name='cubism'
    chooseGanStyleType='cubism'
  }else if(modelType==5){
    GanStyle_subStyle_name='elf'
    chooseGanStyleType='elf'
  }else if(modelType==6){
    GanStyle_subStyle_name='sketch_hq'
    chooseGanStyleType='sketch_hq'
  }else if(modelType==7){
    GanStyle_subStyle_name='thomas'
    chooseGanStyleType='thomas'
  }else if(modelType==8){
    GanStyle_subStyle_name='thanos'
    chooseGanStyleType='thanos'
  }else if(modelType==9){
    GanStyle_subStyle_name='simpson'
    chooseGanStyleType='simpson'
  }else if(modelType==10){
    GanStyle_subStyle_name='witcher'
    chooseGanStyleType='witcher'
  }else if(modelType==11){
    GanStyle_subStyle_name='edvard_munch'
    chooseGanStyleType='edvard_munch'
  }else if(modelType==12){
    GanStyle_subStyle_name='ukiyoe'
    chooseGanStyleType='ukiyoe'
  }else if(modelType==13){
    GanStyle_subStyle_name='botero'
    chooseGanStyleType='botero'
  }else if(modelType==14){
    GanStyle_subStyle_name='shrek'
    chooseGanStyleType='shrek'
  }else if(modelType==15){
    GanStyle_subStyle_name='joker'
    chooseGanStyleType='joker'
  }else if(modelType==16){
    GanStyle_subStyle_name='pixar'
    chooseGanStyleType='pixar'
  }else if(modelType==17){
    GanStyle_subStyle_name='zombie'
    chooseGanStyleType='zombie'
  }else if(modelType==18){
    GanStyle_subStyle_name='werewolf'
    chooseGanStyleType='werewolf'
  }else if(modelType==19){
    GanStyle_subStyle_name='groot'
    chooseGanStyleType='groot'
  }else if(modelType==20){
    GanStyle_subStyle_name='ssj'
    chooseGanStyleType='ssj'
  }else if(modelType==21){
    GanStyle_subStyle_name='rick_morty_cartoon'
    chooseGanStyleType='rick_morty_cartoon'
  }else if(modelType==22){
    GanStyle_subStyle_name='anime'
    chooseGanStyleType='anime'
  }else if(modelType==23){
    GanStyle_subStyle_name='white_walker'
    chooseGanStyleType='white_walker'
  }else if(modelType==24){
    GanStyle_subStyle_name='zuckerberg'
    chooseGanStyleType='zuckerberg'
  }else if(modelType==25){
    GanStyle_subStyle_name='disney_princess'
    chooseGanStyleType='disney_princess'
  }else{

  }
  return chooseGanStyleType;
  
}




export async function generateGanStyle(execAiType, selectedGanStyleType) {
  //todo 生成藝術

  var yourPrompt=document.getElementById('search-bar').value;
  var yourSeedText=Math.floor(Math.random() * (45555 - 1024 + 1)) + 1024;
  var yourNumOutPutText=1;
  // document.getElementById('initFileUrl').value="https://firebasestorage.googleapis.com/v0/b/pixeldraw007.appspot.com/o/okkh4IU63rY5cReBx39dqBomfyB3%2Ftest?alt=media&token=14ffeedd-212b-46df-a49a-66564607ba13"

  var initFileUrl=document.getElementById('initFileUrl').value;

  var aiType=0;
  var settingParams=['0','0','0','base']
  if(execAiType=='doodle2Pic0'){
    aiType=0;
  }else if(execAiType=='0'){
    aiType=0;
  }else if(execAiType=='1'){
    aiType=1;
  }else if(execAiType=='2'){
    aiType=2;
  }else if(execAiType=='3'){
    aiType=3;
  }else if(execAiType=='4'){

  }else if(execAiType=='5'){
    aiType=5;
    
    settingParams=[settingParams[0],settingParams[1],settingParams[2],selectedGanStyleType]
    initFileUrl=document.getElementById('ganStyleInitImgUrlValue').value;
  }else{

  }

  console.log('initFileUrl:'+initFileUrl)
  var maskFileUrl='';
  var art_width=512;
  var art_height=384;
  console.log('generateImgReq params',aiType,yourPrompt,yourSeedText,yourNumOutPutText,initFileUrl,maskFileUrl,art_width,art_height);
    
  //
  document.getElementById("confirmBtn").style="display:block;"
  document.getElementById("promptDetailDialog").showModal();
  document.getElementById("promptP1").innerHTML = 'in progress,it may take a minute';
  document.getElementById("promptP2").innerHTML = 'if it exceeds one minute, there may be a timeout tip';
  //
  var resultArr=await generateImgReq(aiType,yourPrompt,yourSeedText,yourNumOutPutText,initFileUrl,maskFileUrl,art_width,art_height,settingParams);
  //
  document.getElementById("confirmBtn").style="display:none;"
  document.getElementById("promptDetailDialog").close();
  document.getElementById("promptP1").innerHTML = '';
  //
  if(resultArr=='code:1025,msg:sorry,something wrong'){
    alert('sorry, System response timed out')
    return;
  }
  if(resultArr=='code:1024,msg:sorry,something wrong 1'){
    alert(resultArr)
    return;
  }
  if(resultArr=='code:1024,msg:sorry,something wrong 2'){
    alert(resultArr)
    return;
  }
  if(aiType!=5){
    if (typeof resultData === 'string') {
      console.log('resultData is a string');
      alert(resultData);
      return;
    }
  }

  var resultHtml=''
  //
  if(resultArr!=undefined){
    resultHtml='<br/><img id="resultText" src="'+resultArr+'">';
    
  }
  //
  document.getElementById('output').innerHTML='';
  document.getElementById('output2').innerHTML='';
  document.getElementById('output').innerHTML=resultHtml;

}